import React from "react";
import { Link } from "react-router-dom";
import { ShoppingCart, ArrowRight, Truck } from "lucide-react";
import { motion } from "framer-motion";
import HeroImage from "./Images/Banner1.jpg";

export default function HeroSection() {
  return (
    <section className="relative bg-[#fafafa] py-16 lg:py-24 overflow-hidden mt-8">
      
      {/* Soft Background Glow */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-yellow-400/10 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-yellow-500/5 rounded-full blur-[80px] translate-y-1/2 -translate-x-1/2 pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center gap-12 lg:gap-20 relative z-10">

        {/* LEFT */}
        <div className="flex-1 text-left space-y-6">

          {/* Badge */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-yellow-100 border border-yellow-200"
          >
            <span className="bg-yellow-500 text-black text-[10px] font-bold px-2 py-0.5 rounded-full">
              NEW
            </span>
            <span className="text-yellow-600 text-xs font-semibold uppercase flex items-center gap-1">
              Welcome To Daily Go <Truck size={12} />
            </span>
          </motion.div>

          {/* Heading */}
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-tight"
          >
            Daily Wholesale <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-yellow-400">
              Deals & Savings
            </span>
          </motion.h1>

          {/* Subtext */}
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-gray-600 text-base md:text-lg leading-relaxed max-w-lg"
          >
            Unlock unbeatable wholesale prices every day. Shop smart,
            save more, and stock up with the most trusted B2B partner.
          </motion.p>

          {/* Buttons */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="flex flex-wrap gap-4 pt-2"
          >
            <Link
              to="/ServiceIndex"
              className="group px-8 py-3 bg-yellow-500 text-black font-bold rounded-full shadow-md hover:bg-yellow-400 transition flex items-center gap-2"
            >
              Explore Services 
              <ArrowRight size={18} className="group-hover:translate-x-1 transition" />
            </Link>
            
            <Link
              to="/JoinUsIndex"
              className="px-8 py-3 border border-gray-300 text-gray-800 font-semibold rounded-full hover:bg-gray-100 transition flex items-center gap-2"
            >
              <ShoppingCart size={18} /> Join Now
            </Link>
          </motion.div>
        </div>

        {/* RIGHT */}
        <motion.div 
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          className="flex-1 relative hidden md:flex justify-center items-center"
        >
          {/* Subtle Shapes */}
          <div className="absolute -bottom-6 -right-6 w-[250px] h-[250px] bg-yellow-400/20 rounded-[30px]"></div>
          <div className="absolute -top-6 -left-6 w-[200px] h-[200px] bg-gray-200 rounded-full"></div>

          {/* Image */}
          <div className="relative z-10 w-[420px] h-[300px] lg:w-[480px] lg:h-[340px] rounded-2xl overflow-hidden shadow-xl border border-gray-200">
            <img
              src={HeroImage}
              alt="Daily Go Delivery"
              className="w-full h-full object-cover hover:scale-105 transition duration-700"
            />

            {/* Floating Card */}
            <div className="absolute bottom-4 left-4 bg-white border border-gray-200 p-3 rounded-xl flex items-center gap-3 shadow-md">
              <div className="bg-green-500 p-2 rounded-full text-white">
                <Truck size={16} />
              </div>
              <div>
                <p className="text-xs text-gray-500">Delivery Status</p>
                <p className="text-sm font-bold text-gray-900">On Time ⚡</p>
              </div>
            </div>
          </div>
        </motion.div>

      </div>
    </section>
  );
}